import React from "react";
import NavigateButton from "../../Components/UI/Buttons/NavigateButton";

const PageNotFound = () => {
  return (
    <div className="flex flex-col border-4 border-[#E0F5FD] overflow-autoh-full w-full items-center justify-center py-16 bg-gray-100 bg-opacity-30 h-full">
      <h1 className="text-6xl font-bold mb-4">404</h1>
      <p className="text-xl mb-8">
        Oops! The page you're looking for doesn't exist.
      </p>
      <div className="py-2">
        <NavigateButton text="back" type="home" />
      </div>
    </div>
  );
};

export default PageNotFound;
